import {
  Button,
  Card,
  DatePicker,
  Dialog,
  Input,
  Message,
  NumberPicker,
  Select,
  Table,
} from '@alifd/next';
import { Form } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import EditDocument from '@/components/UI/EditDocument';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const Option = Select.Option;

const LeaseManagement = () => {
  const [leaseManagementForm] = Form.useForm();
  const [leaseManagementRecordForm] = Form.useForm();
  const leaseManagement = client.service('leaseManagement');
  const [leaseManagementAddDialog, setLeaseManagementAddDialog] =
    useState(false);

  const [leaseManagementUpdate, setLeaseManagementUpdate] = useState({});
  const [leaseManagementStatus, setLeaseManagementStatus] = useState('insert');
  const [isUpdate, setIsUpdate] = useState(false);
  const [leaseManagementArr, setLeaseManagementArr] = useState([]);
  const [leaseManagementDialog, setLeaseManagementDialog] = useState(false);
  const [leaseManagementRecordDialog, setLeaseManagementRecordDialog] =
    useState(false);
  const [currentLeaseManagementRecord, setCurrentLeaseManagementRecord] =
    useState();

  useEffect(() => {
    leaseManagement
      .find({ query: {} })
      .then((result) => {
        const newResultObj = result.data.map((item) => {
          const newItem = {
            ...item,
            status: false,
          };
          item.parkingRecord.map((record) => {
            if (
              record.parkingRecordStart <= moment().valueOf() &&
              record.parkingRecordEnd >= moment().valueOf()
            ) {
              newItem.status = true;
              newItem.start = record.parkingRecordStart;
              newItem.end = record.parkingRecordEnd;
            }
            return true;
          });
          return newItem;
        });
        setLeaseManagementArr(newResultObj);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [isUpdate, leaseManagement]);

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 4,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 20,
      },
    },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 20,
        offset: 4,
      },
    },
  };

  const onFinish = (value) => {
    const newParkingObject = {
      ...value,
      parkingExpenses: parseInt(value.parkingExpenses, 10),
      parkingRecord: [],
    };
    if (leaseManagementStatus === 'insert') {
      leaseManagement
        .create(newParkingObject)
        .then(() => {
          Message.success('新增成功');
          setLeaseManagementAddDialog(false);
          setIsUpdate((pre) => !pre);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      leaseManagement
        .patch(leaseManagementUpdate._id, newParkingObject)
        .then(() => {
          Message.success('修改成功');
          setLeaseManagementAddDialog(false);
          setIsUpdate((pre) => !pre);
          leaseManagementForm.resetFields();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const onFinishRecord = (value) => {
    const { parkingRecordStart, parkingRecordEnd } = value;
    let newRecords;
    if (currentLeaseManagementRecord) {
      newRecords = leaseManagementUpdate.parkingRecord.map((item) => {
        if (item.createdTime === currentLeaseManagementRecord.createdTime) {
          return {
            ...item,
            ...value,
            parkingRecordStart: parkingRecordStart.valueOf(),
            parkingRecordEnd: parkingRecordEnd.valueOf(),
          };
        }
        return item;
      });
    } else {
      newRecords = [
        ...leaseManagementUpdate.parkingRecord,
        {
          ...value,
          parkingRecordStart: parkingRecordStart.valueOf(),
          parkingRecordEnd: parkingRecordEnd.valueOf(),
          createdTime: moment().valueOf(),
        },
      ];
    }
    leaseManagement
      .patch(leaseManagementUpdate._id, {
        parkingRecord: newRecords,
      })
      .then(() => {
        Message.success(
          `${currentLeaseManagementRecord ? '編輯' : '新增'}租賃記錄成功`
        );
        setIsUpdate((pre) => !pre);
        setLeaseManagementRecordDialog(false);
        setCurrentLeaseManagementRecord(undefined);
        leaseManagement
          .find({ query: { _id: leaseManagementUpdate._id } })
          .then((result) => {
            setLeaseManagementUpdate(result.data[0]);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteLeaseManagementRecord = async (record) => {
    const newRecords = leaseManagementUpdate.parkingRecord.filter(
      (item) => item.createdTime !== record.createdTime
    );
    await leaseManagement
      .patch(leaseManagementUpdate._id, {
        parkingRecord: newRecords,
      })
      .then(() => {
        Message.success('刪除租賃記錄成功');
        setIsUpdate((pre) => !pre);
        setLeaseManagementRecordDialog(false);
        setCurrentLeaseManagementRecord(undefined);
        leaseManagement
          .find({ query: { _id: leaseManagementUpdate._id } })
          .then((result) => {
            setLeaseManagementUpdate(result.data[0]);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Button
        onClick={() => {
          setLeaseManagementAddDialog(true);
          setLeaseManagementStatus('insert');
          leaseManagementForm.setFieldsValue({
            parkingNum: 1,
          });
        }}
      >
        新增停車資訊
      </Button>
      <EditDocument name="租賃管理" style={{ marginLeft: 10 }} />

      <Dialog
        hasMask
        className={styles.dialog}
        visible={leaseManagementAddDialog}
        onOk={() => {
          leaseManagementForm.submit();
        }}
        onCancel={() => {
          setLeaseManagementAddDialog(false);
          leaseManagementForm.resetFields();
        }}
        onClose={() => {
          setLeaseManagementAddDialog(false);
          leaseManagementForm.resetFields();
        }}
      >
        <h1>{leaseManagementStatus === 'insert' ? '新增' : '修改'}停車資訊</h1>

        <Form
          form={leaseManagementForm}
          name="dynamic_form_item"
          onFinish={onFinish}
          {...formItemLayoutWithOutLabel}
        >
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請輸入車位編號',
              },
            ]}
            label="車位編號"
            name="parkingSpaceNumber"
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="繳費週期"
            required={[{ required: true, message: '請選擇租賃週期' }]}
            {...formItemLayout}
          >
            <div className={styles.workingBox}>
              每
              <Form.Item
                name="parkingNum"
                noStyle
                rules={[
                  {
                    required: true,
                    message: '請選擇天數',
                  },
                ]}
              >
                <NumberPicker min={0} />
              </Form.Item>
              <Form.Item
                noStyle
                name="parkingUnit"
                rules={[
                  {
                    required: true,
                    message: '請選擇時段',
                  },
                ]}
              >
                <Select hasClear placeholder="請選擇時段" aria-label="name is">
                  <Option value="小時">小時</Option>
                  <Option value="天">天</Option>
                  <Option value="月">月</Option>
                  <Option value="年">年</Option>
                  <Option value="季">季</Option>
                </Select>
              </Form.Item>
              計算
            </div>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇輸入長期維修預算',
              },
            ]}
            label="費用"
            name="parkingExpenses"
          >
            <Input innerAfter="元" />
          </Form.Item>
        </Form>
      </Dialog>
      {/* 查看維修記錄 */}

      <Dialog
        hasMask
        className={styles.dialog}
        visible={leaseManagementDialog}
        onOk={() => {
          setLeaseManagementDialog(false);
        }}
        onCancel={() => {
          setLeaseManagementDialog(false);
        }}
        onClose={() => {
          setLeaseManagementDialog(false);
        }}
      >
        <h1>查看租賃記錄</h1>
        <Button
          type="normal"
          onClick={() => {
            setCurrentLeaseManagementRecord(undefined);
            leaseManagementRecordForm.resetFields();
            setLeaseManagementRecordDialog(true);
          }}
          style={{ marginBottom: '20px' }}
        >
          新增租賃記錄
        </Button>
        <Table dataSource={leaseManagementUpdate.parkingRecord}>
          <Table.Column
            dataIndex="createdTime"
            title="新增時間"
            cell={(value) => moment(value).format('YYYY-MM-DD')}
          />
          <Table.Column dataIndex="parkingRecordPeople" title="租賃人" />
          <Table.Column dataIndex="parkingRecordPhone" title="租賃電話" />
          <Table.Column
            dataIndex="parkingRecordStart"
            title="租賃開始時間"
            cell={(value) => moment(value).format('YYYY-MM-DD')}
          />
          <Table.Column
            dataIndex="parkingRecordEnd"
            title="租賃結束時間"
            cell={(value) => moment(value).format('YYYY-MM-DD')}
          />
          <Table.Column
            title="操作"
            cell={(_value, _index, record) => {
              return (
                <div className={styles['dialog-manipulate']}>
                  <Button
                    onClick={() => {
                      setLeaseManagementRecordDialog(true);
                      setCurrentLeaseManagementRecord(record);
                      leaseManagementRecordForm.setFieldsValue({
                        ...record,
                        parkingRecordStart: moment(record.parkingRecordStart),
                        parkingRecordEnd: moment(record.parkingRecordEnd),
                      });
                    }}
                  >
                    編輯
                  </Button>
                  <Button
                    warning
                    onClick={() => {
                      deleteLeaseManagementRecord(record);
                    }}
                  >
                    刪除
                  </Button>
                </div>
              );
            }}
          />
        </Table>
      </Dialog>

      {/* 新增編輯維修記錄 */}
      <Dialog
        name="dynamic_form_item"
        hasMask
        className={styles.dialog}
        visible={leaseManagementRecordDialog}
        onOk={() => {
          leaseManagementRecordForm.submit();
        }}
        onCancel={() => {
          setCurrentLeaseManagementRecord(undefined);
          setLeaseManagementRecordDialog(false);
        }}
        onClose={() => {
          setCurrentLeaseManagementRecord(undefined);
          setLeaseManagementRecordDialog(false);
        }}
      >
        <h1>{`${currentLeaseManagementRecord ? '編輯' : '新增'}租賃記錄`}</h1>
        <Form
          form={leaseManagementRecordForm}
          onFinish={onFinishRecord}
          {...formItemLayoutWithOutLabel}
        >
          <Form.Item
            label="租賃人"
            name="parkingRecordPeople"
            rules={[
              {
                required: true,
                message: '請輸入租賃人',
              },
            ]}
            {...formItemLayout}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="租賃電話"
            name="parkingRecordPhone"
            rules={[
              {
                required: true,
                message: '請輸入租賃電話',
              },
            ]}
            {...formItemLayout}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="租賃開始時間"
            name="parkingRecordStart"
            rules={[
              {
                required: true,
                message: '請輸入租賃開始時間',
              },
            ]}
            {...formItemLayout}
          >
            <DatePicker type="date" />
          </Form.Item>
          <Form.Item
            label="租賃結束時間"
            name="parkingRecordEnd"
            rules={[
              {
                required: true,
                message: '請輸入租賃結束時間',
              },
            ]}
            {...formItemLayout}
          >
            <DatePicker type="date" />
          </Form.Item>
        </Form>
      </Dialog>

      <br />
      <br />
      <Card free>
        <Card.Content>
          <Table dataSource={leaseManagementArr}>
            <Table.Column
              title="車位編號"
              width={100}
              dataIndex="parkingSpaceNumber"
            />
            <Table.Column
              title="車位狀態"
              dataIndex="status"
              width={100}
              cell={(value) => {
                if (value) {
                  return '已租賃';
                } else {
                  return '空閒中';
                }
              }}
            />
            <Table.Column
              dataIndex="start"
              title="租賃開始時間"
              cell={(value, _index, record) => {
                if (record.status) {
                  return moment(value).format('YYYY-MM-DD');
                }
              }}
            />
            <Table.Column
              dataIndex="end"
              title="租賃結束時間"
              cell={(value, _index, record) => {
                if (record.status) {
                  return moment(value).format('YYYY-MM-DD');
                }
              }}
            />
            <Table.Column
              title="車位繳費週期"
              width={200}
              cell={(_value, _index, record) => {
                return (
                  <>
                    每{record.parkingNum}
                    {record.parkingUnit}
                    {record.parkingExpenses}元
                  </>
                );
              }}
            />

            <Table.Column
              title="操作"
              width={350}
              cell={(_value, _index, record) => {
                return (
                  <div className={styles.btnGroup}>
                    <Button
                      type="primary"
                      onClick={() => {
                        setLeaseManagementUpdate(record);
                        setLeaseManagementDialog(true);
                      }}
                    >
                      查看租賃記錄
                    </Button>

                    <Button
                      type="normal"
                      onClick={() => {
                        setLeaseManagementStatus('update');
                        setLeaseManagementUpdate(record);
                        setLeaseManagementAddDialog(true);
                        leaseManagementForm.setFieldsValue({
                          ...record,
                        });
                      }}
                    >
                      編輯
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        leaseManagement
                          .remove(record._id)
                          .then(() => {
                            Message.success('刪除成功');
                            setIsUpdate((pre) => !pre);
                          })
                          .catch((error) => console.log(error));
                      }}
                      warning
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            />
          </Table>
        </Card.Content>
      </Card>
    </>
  );
};

export default LeaseManagement;
